// StoreHoursAnchor, shared by the task editor and the scheduled list so the two cannot describe the same
// task differently.

import i18n from '../i18n/index.js';

// Mirrors the C# enum's NAMES and its ordinal order. Both forms are accepted on the way in because this
// value has reached clients both ways: the API serialises enums by name, while the admin inventory reads
// the raw stored document, where the same field is an ordinal.
export const ANCHOR_NAMES = ['None', 'Open', 'Close'];

export function anchorName(value) {
  if (typeof value === 'number') return ANCHOR_NAMES[value] || 'None';
  return ANCHOR_NAMES.includes(value) ? value : 'None';
}

export function isAnchored(value) {
  return anchorName(value) !== 'None';
}

/**
 * "at close", "30 minutes before close", "15 minutes after open".
 *
 * The wording CadenceDescriber.DescribeAnchor produces server-side. Kept here rather than at each call
 * site because the offset is the whole difference between the anchor and the time a task actually fires:
 * a summary that drops it describes a schedule its owner never chose.
 */
export function describeAnchor(anchor, offsetMinutes) {
  // Whole-sentence keys resolved through i18n plural forms (scheduled.anchor.*) rather than a hand-rolled
  // singular/plural toggle, so every language gets to pluralize and word-order its own way. The exported
  // signature is unchanged.
  const t = i18n.global.t.bind(i18n.global);
  const open = anchorName(anchor) === 'Open';
  const minutes = Number(offsetMinutes) || 0;
  if (!minutes) return t(open ? 'scheduled.anchor.atOpen' : 'scheduled.anchor.atClose');
  const when = minutes < 0 ? 'Before' : 'After';
  const edge = open ? 'Open' : 'Close';
  return t(`scheduled.anchor.minutes${when}${edge}`, Math.abs(minutes), { count: Math.abs(minutes) });
}
